import React from "react";
import { Modal } from "antd";
import { IDLE_LIMIT_MS, IDLE_WARNING_MS } from "../brand";

const ACTIVITY_EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "scroll",
  "touchstart",
  "wheel",
];

// Signs the user out after IDLE_LIMIT_MS without mouse or keyboard use,
// with a countdown for the last IDLE_WARNING_MS. Use inside an embedded app
// can't be seen from here (it is another site), so while one of those has
// the focus the user counts as active and that app's own session rules apply.
export default function IdleSignOut({ onSignOut }) {
  const lastActivity = React.useRef(Date.now());
  const warningRef = React.useRef(false);
  const [secondsLeft, setSecondsLeft] = React.useState(null);

  React.useEffect(() => {
    const markActive = () => {
      if (!warningRef.current) lastActivity.current = Date.now();
    };
    ACTIVITY_EVENTS.forEach((name) =>
      window.addEventListener(name, markActive, { passive: true }),
    );

    const timer = setInterval(() => {
      if (document.activeElement?.tagName === "IFRAME" && !warningRef.current) {
        lastActivity.current = Date.now();
      }
      const idle = Date.now() - lastActivity.current;
      if (idle >= IDLE_LIMIT_MS) {
        clearInterval(timer);
        onSignOut();
        return;
      }
      if (idle >= IDLE_LIMIT_MS - IDLE_WARNING_MS) {
        warningRef.current = true;
        setSecondsLeft(Math.ceil((IDLE_LIMIT_MS - idle) / 1000));
      }
    }, 1000);

    return () => {
      clearInterval(timer);
      ACTIVITY_EVENTS.forEach((name) =>
        window.removeEventListener(name, markActive),
      );
    };
  }, [onSignOut]);

  const stay = () => {
    warningRef.current = false;
    lastActivity.current = Date.now();
    setSecondsLeft(null);
  };

  return (
    <Modal
      open={secondsLeft !== null}
      title="Are you still there?"
      okText="Stay signed in"
      cancelText="Sign out now"
      onOk={stay}
      onCancel={onSignOut}
      closable={false}
      maskClosable={false}
      keyboard={false}
      centered
    >
      <p>
        For your security you will be signed out in{" "}
        <strong>{secondsLeft} seconds</strong> because there has been no
        activity.
      </p>
    </Modal>
  );
}
